import {
  addressProperties,
  addressRequired,
  customValidate
} from 'common/components/address/validators';
import { validateForUI } from 'common/helpers/jsonValidator';

const addressSchema = () => {
  const schema = {
    type: 'object',
    properties: addressProperties,
    required: addressRequired,
    additionalProperties: false
  };
  schema.properties.isDefault = { type: 'boolean' };
  return schema;
};

export const validateAdd = (address, settings) => {
  const errors = validateForUI(
    addressSchema(),
    address,
    customValidate(address, 'addressBook', settings)
  );
  return errors;
};

export const validateEdit = (address, settings) => {
  const errors = validateForUI(
    addressSchema(),
    address,
    customValidate(address, 'addressBook', settings)
  );
  return errors;
};
